import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Assignment, Add, Create, FileCopySharp } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { wsFindBy, wsUpdate } from 'services/WService.js';
import { Toasty, useToasty } from 'hooks/Toasty';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { WithApp } from 'contexts/appContext';
import { useModal } from 'hooks/useModal';
import Modal from './Modal';
import ButtonDelete from 'hooks/ButtonDelete';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Periodo', accessor: 'Periodo', width: 100 },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Días', accessor: 'days', width: 180 },
  { Header: 'Cuota', accessor: 'quota', width: 180, excelEnabled: false },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function LinealitiesClorox(props) {
  const classes = useStyles();

  const [linealities, setLinealities] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [dataLoading, setDataLoading] = useState(false);
  const [notify, showNotify] = useToasty();
  const [model, setOpen] = useModal();

  const handleChange = (id, field, value) => {
    const index = linealities.findIndex((item) => item.id == id);
    if (index >= 0) {
      linealities[index][field] = value;
      setLinealities([...linealities]);
    }
  };

  async function loadLinealities(filter) {
    setDataLoading(true);
    let response = await wsFindBy('sale/clorox-linearities', filter);
    setDataLoading(false);
    if (response.success) setLinealities(response.data);
  }

  async function updateLineality(id, field, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/clorox-linearities', id, { Periodo: valueSearch.Periodo, [field]: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      loadLinealities(valueSearch);
    } else {
      showNotify(response.message, 'error');
    }
  }

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadLinealities(valueSearch)}
          valueSearch={valueSearch}
        />
      ) : undefined}
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Linealidades Clorox{dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadLinealities}
              getValueSearch={(value) => setValueSearch(value)}
              date
              dateType="month"
              labelDate="Periodo"
              dateField="Periodo"
            />
            <ReactTable
              excelName="linealidades_clorox"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={linealities.map((item, i) => ({
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}>
                      <Button
                        justIcon
                        round
                        simple
                        color={props.themeContext.buttonColorWarning}
                        onClick={() => setOpen(item)}
                      >
                        <Create />
                      </Button>
                    </AllowedGuard>
                    <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_DELETED}>
                      <ButtonDelete
                        entity="sale/clorox-linearities"
                        id={item.id}
                        reload={() => {
                          setDataLoading(true);
                          loadLinealities(valueSearch).then(() => setDataLoading(false));
                        }}
                      />
                    </AllowedGuard>
                  </div>
                ),
                Periodo: item.Periodo,
                days: item.days || '',
                description: item.description,
                quota: (
                  <AllowedGuard
                    permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                    component={item.quota}
                  >
                    <TextField
                      fullWidth
                      type="number"
                      name="cuota"
                      margin="normal"
                      value={item.quota || ''}
                      onChange={(e) => handleChange(item.id, 'quota', e.target.value)}
                      onBlur={(e) => updateLineality(item.id, 'quota', e.target.value)}
                    />
                  </AllowedGuard>
                ),
                actions: '',
              }))}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
